<template>
    <div class="footer__container">

        <div class="items">

            <div class="logo__column">
                <img src="/images/footer/gate21.webp" class="gate__logo__footer" alt="GATE21">
                <img src="/images/thq_logo_white.webp" class="thq__logo__footer" alt="THQ Nordic">
                <p class="thq__text">FAMILY MEMBER</p>
                <p class="desc">
                    We are Sarajevo based studio focused <br>on rigging and pipeline solutions.
                </p>
            </div>

            <div class="information__items">

                <div class="mobile-column">

                    <div class="info__column">
                        <p class="title">HEADQUARTERS</p>
                        <div class="location">
                            <img src="/images/footer/map.webp" alt="map">
                            <p>
                                Gate21 d.o.o. Sarajevo 
                                <br>Vrbanja 1, 71000 Sarajevo <br>Bosna i Hercegovina
                            </p>
                        </div>
                        <div class="address">
                            <img src="/images/footer/email.webp" alt="email">
                            <p>
                                info@gate21.com
                            </p>
                        </div>
                    </div>

                    <div class="info__column">
                        <p class="title">MENU LINKS</p>
                        <a class="link" href="/">Home</a>
                        <a class="link" href="/projects">Projects</a>
                        <a class="link" href="/news">News</a>
                        <a class="link" href="/contact">Contact us</a>
                        <a class="link" href="/careers">Careers</a>
                    </div>

                </div>

                <div class="mobile-column-reverse">

                    <div class="info__column">
                        <p class="title">QUICK LINKS</p>
                        <!-- <a class="link" href="">FAQ</a> -->
                        <a class="link" href="/privacypolicy">Privacy Policy</a>
                    </div>

                    <div class="info__column">
                        <p class="title">SOCIAL MEDIA</p>

                        <div class="social__row">
                            <a class="social__link" href="https://www.facebook.com/GateTwentyOne/" target="_blank" ><img src="/images/footer/fb.webp" alt="Facebook"></a>
                            <!-- <a class="social__link" href=""><img src="/images/footer/ig.webp" alt="Instagram"></a> -->
                            <a class="social__link" href="https://www.linkedin.com/company/gate21doo" target="_blank"><img src="/images/footer/li.webp" alt="LinkedIn"></a>
                            <!-- <a class="social__link yt" href=""><img src="/images/footer/yt.webp" alt="Youtube"></a> -->
                        </div>

                    </div>

                </div>

            </div>
            
        </div>
        
        <div class="bottom">
            <p><strong>GATE21 d.o.o.</strong> Sarajevo © {{get_year()}}. All rights reserved.</p>
            <p class="left__margin">made by &nbsp;<a href="https://purplekey.ba/" target="_blank">purplekey.ba</a></p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            text: "Vue3 component."
        }
    },
    props: ['is_section'],
    methods: {
        get_year(){
            const d = new Date();
            return d.getFullYear();
        }
    }
}
</script>
<style lang="scss" scoped>
    .footer__container{
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 396px;

        background: #1A1A1A;

        .items{

            display: flex;
            flex-direction: row;
            justify-content: space-around;
            margin-top: auto;
            margin-bottom: 0;

            width: 100%;
            max-width: 1920px;
            // overflow-x: hidden;
            margin-left: auto;
            margin-right: auto;


            .logo__column{
                display: flex;
                flex-direction: column;
                width: 275px;
                justify-content: center;

                .gate__logo__footer{
                    display: block;
                    width: 44px;
                    height: 97px;
                    margin-left: auto;
                    margin-right: auto;
                    margin-bottom: 31px;
                }

                .thq__logo__footer{
                    display: block;
                    width: 123px;
                    height: 20px;
                    margin-left: auto;
                    margin-right: auto;
                }

                .thq__text{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-size: 14px;
                    line-height: 14px;
                    /* identical to box height, or 14px */
                    text-align: center;

                    letter-spacing: 0.09em;
                    text-transform: uppercase;
                    color: white;

                    margin-top: 4px;
                    margin-bottom: 20px;
                }

                .desc{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-size: 16px;
                    line-height: 25px;
                    /* or 156% */

                    text-align: center;

                    color: #FFFFFF;
                    margin: 0;
                }
            }

            .information__items{
                display: flex;
                flex-direction: row;
                width: 100%;
                max-width: 1033px;

                .mobile-column, .mobile-column-reverse{
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    justify-content: space-around;
                    

                    .info__column{
                        display: flex;
                        flex-direction: column;


                        .title{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 500;
                            font-size: 20px;
                            line-height: 25px;
                            /* identical to box height, or 125% */

                            margin-bottom: 35px;
                            color: #FFFFFF;
                        }

                        .location, .address{
                            display: flex;
                            flex-direction: row;
                        }

                        .location{
                            img{
                                display: block;
                                width: 14px;
                                height: 25px;
                                margin-top: 4px;
                                margin-right: 16px;
                            }

                            p{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 25px;
                                /* or 179% */

                                color: #FFFFFF;
                                margin: 0;
                            }

                            margin-bottom: 24px;
                        }

                        .address{
                            img{
                                display: block;
                                width: 21px;
                                height: 16px;
                                margin-top: 4px;
                                margin-right: 11px;
                            }

                            p{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 25px;
                                /* or 179% */

                                color: #FFFFFF;
                                margin: 0;
                            }
                        }

                        .link{
                            text-decoration: none;
                            
                            font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 25px;
                            /* or 179% */

                            color: #FFFFFF;
                        }

                        .social__row{
                            display: flex;
                            flex-direction: row;

                            .social__link{
                                display: block;
                                margin-right: 15px;

                                width: 27px;
                                height: 27px;

                                &.yt{
                                    width: 31px;
                                    height: 23px;
                                }

                                img{
                                    display: block;
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }

                    }

                }

            }

            

        }

        .bottom{
            background: #151515;
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 0;

            p{
                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 700;
                font-size: 12px;
                line-height: 25px;
                /* or 208% */

                &.left__margin{
                    margin-left: 40px;
                }

                color: #FFFFFF;

                a{
                    color: white;
                    font-weight: bold;
                    text-decoration: none;
                }
            }
        }
    }

    @media screen and (max-width: 1750px) {
        .footer__container{

            .items{
                max-width: 1111px;
            }

        }
    }

    @media screen and (max-width: 836px) {

        .footer__container{

            .items{
                flex-direction: column;

                .logo__column{
                    margin-top: 21px;
                    margin-left: auto;
                    margin-right: auto;
                }

                .information__items{
                    width: auto;
                    // padding: 0 23px;
                    margin: 12px 0;

                    .mobile-column{
                        flex-direction: column;
                        justify-content: flex-start;

                        border-top: 1px solid #ED1163;
                        border-bottom: 1px solid #ED1163;

                        .info__column{
                            padding: 0 23px;
                            min-height: 275px;

                            p.title{
                                margin-left: auto;
                                margin-right: auto;
                            }

                            .link{
                                margin-left: auto;
                                margin-right: auto;
                            }
                        }
                    }

                    .mobile-column-reverse{
                        flex-direction: column-reverse;
                        justify-content: flex-end;

                        border-top: 1px solid #ED1163;
                        border-bottom: 1px solid #ED1163;
                        border-left: 1px solid #ED1163;

                        .info__column{
                            padding: 0 23px;
                            min-height: 275px;

                            p.title{
                                margin-left: auto;
                                margin-right: auto;
                            }

                            .social__row{
                                flex-wrap: wrap;
                                max-width: 110px;
                                margin-left: auto;
                                margin-right: auto;

                                // since 3 items only are present
                                flex-direction: column;

                                .social__link{
                                    margin-left: 12px;
                                    margin-right: 12px;
                                    // margin-bottom: 40px;
                                    margin-bottom: 35px;
                                }
                            }

                            .link{
                                margin-left: auto;
                                margin-right: auto;
                            }
                        }
                    }
                }
            }

            .bottom{
                flex-direction: column;

                p, p.left__margin{
                    margin: 0;
                    margin-left: auto;
                    margin-right: auto;
                }                

                p.left__margin{
                    margin-bottom: 8px;
                }
            }

        }

    }
</style>